import h from 'hyperscript';
import downloadIcon from '@disy/cadenza-icons/export.svg';

import { Modal } from 'ui/dialog/modal/modal';
import { RadioGroup } from 'ui/radio-group/radio-group';

import { on } from 'cadenza/utils/event-util';
import { icon } from 'cadenza/utils/icon/icon';
import { LayerProperty } from 'cadenza/map/layer-property';
import { MapProperty } from 'cadenza/map/map-property';
import {
  FileExportProgressModal
} from 'cadenza/file-export-progress-dialog/file-export-progress-modal';
import { getAvailableExportOptions, startExport } from 'cadenza/api-client/shapefile-api';
import { LayerAction } from 'cadenza/map/layer-actions/layer-action';
import { logger } from 'cadenza/utils/logging';

import i18n from './layer-actions.properties';

const selectedObjectsName = 'ONLY_SELECTED_OBJECTS';

export class ExportShapeFile extends LayerAction {

  #map;

  constructor (layer, map, options) {
    super(layer, Object.assign({
      icon: icon(downloadIcon),
      label: i18n('mapConfig.layerExportShapeFile')
    }, options));

    this.#map = map.map;
  }

  executeSync () {
    const selectedLayer = this._layer.get(LayerProperty.ID);
    const map = this.#map;
    const mapId = map.get(MapProperty.ID);
    const mapSize = map.getInnerSize();
    const mapExtent = map.getView().calculateVisibleExtent();

    getAvailableExportOptions(mapId, selectedLayer, mapSize, mapExtent).then(availableMapObjectSelections => {
      const exportOptionsMenu = this._createExportOptionsMenu(availableMapObjectSelections);
      const exportOptionsDialog = this._createExportOptionsDialog(exportOptionsMenu);
      on(exportOptionsDialog, 'submit', () => this._onSubmitExportOptions(exportOptionsDialog, exportOptionsMenu));
      exportOptionsDialog.connectAndShow();
    }).catch(error => logger.error('Error on getting available export options.', error));
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && this._layer.get(LayerProperty.EXPORTABLE_AS_SHAPE_FILE);
  }

  _onSubmitExportOptions (exportOptionsDialog, exportOptionsMenu) {
    const selectedLayer = this._layer.get(LayerProperty.ID);
    const map = this.#map;
    const mapId = map.get(MapProperty.ID);
    const mapSize = map.getInnerSize();
    const mapExtent = map.getView().calculateVisibleExtent();
    const dialog = new FileExportProgressModal(
      i18n('layerExport.fileExportProgressDialog.title.shapefile'),
      () => startExport(mapId, selectedLayer, mapSize, mapExtent, exportOptionsMenu.value)
    );
    dialog.startExportAndShowProgress()
      .then(() => exportOptionsDialog.close())
      .catch(() => logger.error('error creating file')); // showing alert is already done inside dialog
  }

  _createExportOptionsDialog (exportOptionsMenu) {
    const exportOptionsDialog = new Modal({
      cancelButton: true,
      submitButton: i18n('layerExport.shapefile.export'),
      title: i18n('layerExport.shapefile.options.title'),
      titleIcon: icon(downloadIcon)
    });
    exportOptionsDialog.body.append(h('form-group.d-stack-v.space-1', [
      h('label', i18n('layerExport.shapefile.subtitle')),
      exportOptionsMenu
    ]));
    return exportOptionsDialog;
  }

  _createExportOptionsMenu (availableMapObjectSelections) {
    const exportOptions = availableMapObjectSelections.map(optionName => {
      return { value: optionName, label: i18n(`layerExport.shapefile.{{${optionName}}}`) };
    });

    if (!availableMapObjectSelections.includes(selectedObjectsName)) {
      exportOptions.unshift({ value: selectedObjectsName, label: i18n(`layerExport.shapefile.{{${selectedObjectsName}}}`), disabled: true });
    }

    return new RadioGroup(exportOptions, {
      initialValue: availableMapObjectSelections[0],
      name: i18n('layerExport.shapefile.options.name')
    });
  }

}
